const SettingsHome = () => <div><h2>Settings</h2></div>
export default SettingsHome;